import React from 'react';

const EditButtonRendered = (props) => {
  const { setOpenEditModal, setSelectedRowData } = props;
  
  const handleClick = () => {
    // Set the selected row data
    if (setSelectedRowData) {
      setSelectedRowData(props.data);
    }
    
    // Open the modal
    setOpenEditModal(true);
  };
  
  return (
    <button
      className='bg-blue-600 text-white px-2  rounded hover:bg-blue-700 transition m-2'
      onClick={handleClick}
    >
      Edit Request
    </button>
  );
};

export default EditButtonRendered;